import * as React from 'react'
import { MuiTextFieldFormik, Props } from './MuiTextFieldFormik'

export const BaseTextField: React.FC<Props> = (props) => {
  const { fullWidth = true, size = 'small', margin = 'none' } = props

  return (
    <MuiTextFieldFormik
      {...props}
      fullWidth={fullWidth}
      size={size}
      margin={margin}
    />
  )
}
BaseTextField.displayName = 'BaseTextField'
